const customisationImages: Record<string, string> = {
  // ...
  //eggstacy
  "BoiledEgg White Peeled": "/eggstacy/boiled-eggs-uncut.png",
  "BoiledEgg White Slices": "/eggstacy/boiled-egg-slices.png",
  "BoiledEgg White Diced": "/eggstacy/eggwhites.png",
  "BoiledEgg White Whites": "/eggstacy/egg-whites.png",
  "BoiledEgg Gold Peeled": "/eggstacy/goldenegg.png",
  "Omlette Bread": "/eggstacy/bread-omlette.png",
  "Omlette Bun": "/eggstacy/bun-omlette.png",
  "Omlette Plain": "/eggstacy/plain-omlette-full.png",
  "Omlette Cheese":"/eggstacy/cheese-omlette.png",
  "Omlette Cheese and Tomato": "/eggstacy/egg-omlette-cheese-tomato.png",
  "Omlette Tomato Chilli Onion": "/eggstacy/egg-omlette-tomato-chilli.png",
  "Omlette Tomato":"/eggstacy/myo-omlette-tomato.png",
  "French Toast":"/eggstacy/french-toast.png",
  "Egg Bajji":"/eggstacy/egg-bajji.png",
  "Egg Chat":"/eggstacy/egg-batani-chat.png",
  "Egg Burji":"/eggstacy/eggbhurji.png",
  "Egg sunflower":"/eggstacy/sun-flower-egg.png",
  "Egg cube carrot":"/eggstacy/egg-carrot-cube.png",
  "Egg cube spinach":"/eggstacy/egg-carrot-cube.png",
  
  
  
  "Plain Dosa": "/host/Dosa.png",
  "Masala Dosa": "/host/Dosa.png",
  "Paper": "/host/paper-dosa.png",
  "Set": "/host/set-dosa.png",
  "Onion": "https://images.unsplash.com/photo-onion-dosa.jpg",
  "Ghee": "https://images.unsplash.com/photo-ghee-dosa.jpg",
  "Butter": "https://images.unsplash.com/photo-butter-food.jpg",
  "Podi": "https://images.unsplash.com/photo-podi.jpg",
  "Karam": "https://images.unsplash.com/photo-spicy-mix.jpg",
  "Coconut chutney": "https://images.unsplash.com/photo-coconut-chutney.jpg",
  "Groundnut chutney": "https://images.unsplash.com/photo-peanut-chutney.jpg",
  "Sambar": "https://images.unsplash.com/photo-sambar.jpg",
  "Roasted": "https://images.unsplash.com/photo-roasted-dosa.jpg",
  "Bubbly": "https://images.unsplash.com/photo-bubbly-dosa.jpg",
  "Mini (Button)": "https://images.unsplash.com/photo-mini-idli.jpg",
  "Idly": "/host/idly.png",
  "Thatte": "https://images.unsplash.com/photo-thatte-idli.jpg",
  "Fried Idly": "https://images.unsplash.com/photo-fried-idli.jpg",
  "Idly Manchurian": "https://images.unsplash.com/photo-idly-manchurian.jpg",
  "Idly Upma": "https://images.unsplash.com/photo-idli-upma.jpg",
  "Sambar Vada": "/host/vada.png",
  "Curd Vada": "https://images.unsplash.com/photo-curd-vada.jpg",
  "Masala Vada": "https://images.unsplash.com/photo-masala-vada.jpg",
  "Chutney Extra": "https://images.unsplash.com/photo-chutney.jpg",
  // Add further mappings here...
};

export default customisationImages;